<!-- =========================================================================================
  File Name: BranchEdit.vue
  Description: Branch Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Empresa no encontrada" :active.sync="id_not_found">
      <span>Datos de ubicación con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'locations'}" class="text-inherit underline">Todas las ubicaciones</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Código de ubicación" v-model="data_local.code" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Nombre de la ubicación" v-model="data_local.name" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Dirección" v-model="data_local.address" :multiline="true" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-dropdownlist highlight=true floatLabelType="Auto" placeholder="Estado" :dataSource="status" :fields="statusFields" v-model="data_local.statusId" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :multiline="true" :enabled="editing"/>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";

  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        status: [],
        data: null,
        statusFields: {text: 'value', value: 'code'},
        data_local: {
          id: 0,
          code: '',
          name: '',
          address: '',
          comments: '',
          statusId: 'IN',
          statusName: ''
        },
        id_not_found: false,
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'locations'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            var data = {
              objectId: id,
              userId: this.$store.state.AppActiveUser.userId,
              token: this.$store.state.AppActiveUser.token
            };
            this.$http.post(deltaPOS_config.default.apiURL + '/lists/locations/data', data).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        var message = '';
        if (!this.data_local.code || this.data_local.code == '') {
          message ='Debe especificar un código';
        } else if (!this.data_local.name || this.data_local.name == '') {
          message = 'Debe especificar un nombre';
        } else if (!this.data_local.statusId || this.data_local.statusId == '') {
          message = 'Debe seleccionar un estado';
        } else {
          var status = this.status.filter(item => item.code == this.data_local.statusId);
          if (status.length <= 0) {
            message = 'Estado incorrecto';
          }
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error al guardar documento',
            text: 'Estado incorrecto',
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de ubicación',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/lists/locations/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la ubicación fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'location', params: {id: response.data.data.id}});
              }
              this.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar ubicación "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando ubicación',
          type: 'point'
        });
        var self = this;
        var data = {
          objectId: this.id,
          userId: this.$store.state.AppActiveUser.userId,
          token: this.$store.state.AppActiveUser.token
        };
        this.$http.post(deltaPOS_config.default.apiURL + '/lists/locations/delete', data).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Empresa fue eliminada correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'locations'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando ubicación',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'ESTADOUBICACION'})
        .then(response => {
          if (response.data.success) {
            self.status = response.data.data;
          }
          this.getData(this.id);
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
